import { GetAgentUserIdResponse } from "@/api/common/commonLimit";
import { List } from "@/components/popoverSelect/limit";

export interface Tag {
  label: string;
  value: string;
  name: string;
  code?: string | undefined | string[];
}

export interface State {
  tagList: List[];
  aliveList: Tag[];
  Companylist: Tag[];
  tagCurrent: Tag;
  tagCurrentData: any;
  thisCompany: unknown;
}

const state: State = {
  tagList: [], // tag列表
  aliveList: [], // 当前缓存列表
  Companylist: [], //公司列表
  // 当前页
  tagCurrent: {
    label: "签约客户",
    value: "/signedCustomer",
    name: "signedCustomer",
  },
  tagCurrentData: {},
  thisCompany: {},
};

const mutations = {
  SET_TAG_CURRENT(state: State, tag: Tag) {
    const arr = new Set(state.aliveList.map((item) => item.value));
    if (!arr.has(tag.value)) state.aliveList.push(tag);
    state.tagCurrent = tag;
  },
  SET_TAG_NAME(state: State, tag: Tag) {
    console.log(tag);
  },
  SET_TAG_LIST(state: State, list: List[]) {
    state.tagList = list;
  },
  SET_TAG_TOKEN(state: State, data: unknown) {
    state.tagCurrentData = data;
  },
  ENT_ERP_RISELIST(state: State, args: Tag[]) {
    state.Companylist = args;
  },
  /** 设置徽标 */
  SET_TAG_BADGES(state: State, data: any) {
    state.tagList.forEach((item) => {
      const o = data.find((n: { companyNumber: string }) => n.companyNumber == item.code);
      console.log(item.dot, o.count);
      item.dot = o.count;
    });
  },
  SET_TAG_THISCOMPANY(state: State, data: unknown) {
    state.thisCompany = data;
  },
};

const getters = {
  getAliveList: (state: State) => state.aliveList,
  getTagCurrent: (state: State) => state.tagCurrent,
  getTagList: (state: State) => state.tagList,
  getTagCurrentData: (state: State) => state.tagCurrentData,
  getTagSmallType: (state: State) => {
    return state.tagCurrentData?.data?.userinfo?.smallType;
  },
  getCompanylist: (state: State) => state.Companylist,
  getThisCompany: (state: State) => state.thisCompany,
};

const actions = {
  setTagList({ commit }: any, data: any[]) {
    commit(
      "SET_TAG_LIST",
      data.map((item): List => {
        return {
          code: item.companyNumber,
          name: item.companyId,
          title: item.companyName,
          itemList: item.itemList,
        };
      })
    );
  },
  setTagToken({ commit }: any, data: any) {
    commit("SET_TAG_TOKEN", data);
  },
  enterpriseList({ commit }: any, args: any) {
    commit("ENT_ERP_RISELIST", args);
  },
  /** 设置徽标 */
  setTagBadges({ commit }: any, data: any) {
    commit("SET_TAG_BADGES", data);
  },
  setThisCompany({ commit }: any, data: any) {
    commit("SET_TAG_THISCOMPANY", data);
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
